exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 800px){\ndiv#sideBar .is-padding-top-0{padding-top:0\n}\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/pages/business/Profile.vue"],"names":[],"mappings":";AACA;AACA,8BAA8B,aAAa;CAC1C;CACA","file":"Profile.vue","sourcesContent":["\n@media screen and (min-width: 800px){\ndiv#sideBar .is-padding-top-0{padding-top:0\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fb2c4f2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/business/Profile.vue
// module id = dxrQ
// module chunks = 4